import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { ActivityIndicatorComponent } from './activity-indicator/activity-indicator-singleton.component';
import { DformLayoutComponent } from './dform-layout/dform-layout.component';
import { AuthLayoutComponent } from './auth-layout/auth-layout.component';
import { HeaderComponent } from './header/header.component';
import { NotificationComponent } from './header/widgets/notification.component';
import { TranslateComponent } from './header/widgets/translate.component';
import { UserComponent } from './header/widgets/user.component';
import { SearchHeaderComponent } from './header/widgets/search-header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { UserPanelComponent } from './sidebar/user-panel.component';
import { SidemenuComponent } from './sidemenu/sidemenu.component';
import { TaskListComponent } from './header/widgets/task_list.component';
import {LogoutComponent} from "@theme/header/widgets/logout.component";

@NgModule({
  declarations: [
    DformLayoutComponent,
    AuthLayoutComponent,
    SidebarComponent,
    UserPanelComponent,
    SidemenuComponent,
    HeaderComponent,
    NotificationComponent,
    TranslateComponent,
    UserComponent,
    SearchHeaderComponent,
    ActivityIndicatorComponent,
    TaskListComponent,
    LogoutComponent
  ],
  imports: [SharedModule],
})
export class ThemeModule {}
